export enum PendulosSiloStatusConfiguracaoEnum {
    CONFIGURADO,
    PARCIALMENTE_CONFIGURADO,
    NAO_CONFIGURADO,
}
